/* TGB gift finder 2026-10-10: separate finished/CYO discovery, no cart mutations. */
(function () {
  'use strict';
  const fields = {occasion: 'filter.p.m.custom.occasion', recipient: 'filter.p.m.custom.recipient', theme: 'filter.p.m.custom.theme'};
  const budgets = ['filter.v.price.gte', 'filter.v.price.lte'];
  const alias = value => ({Appreciation: 'Thank You', 'Buc-ees': 'Buc-ee’s'}[value] || value);
  const cents = value => value === null || value === '' ? null : Math.round(Number(value) * 100);
  function resolve(params, routes) {
    return routes.occasion[params.get(fields.occasion)] || routes.theme[params.get(fields.theme)] || routes.default;
  }
  function fromChoices(values, routes, current) {
    const url = new URL(current);
    [...url.searchParams.keys()].filter(key => key.startsWith('filter.')).forEach(key => url.searchParams.delete(key));
    Object.values(fields).concat(budgets, ['page', 'tgb_page', 'tgb_cyo_page', 'view']).forEach(key => url.searchParams.delete(key));
    Object.entries(fields).forEach(([field, param]) => { if (values[field]) url.searchParams.set(param, values[field]); });
    if (values.budget) {
      const [minimum, maximum] = values.budget.split(':');
      if (minimum !== '') url.searchParams.set(budgets[0], minimum);
      if (maximum !== '') url.searchParams.set(budgets[1], maximum);
    }
    url.pathname = '/collections/' + resolve(url.searchParams, routes);
    url.hash = '';
    url.searchParams.set('view', 'tgb-gift-finder');
    url.searchParams.set('sort_by', url.searchParams.get('sort_by') || 'best-selling');
    return url;
  }
  function relax(current, key, routes) {
    const url = new URL(current);
    (key === 'budget' ? budgets : [fields[key]]).forEach(param => url.searchParams.delete(param));
    url.searchParams.delete('page'); url.searchParams.delete('tgb_page'); url.searchParams.delete('tgb_cyo_page');
    if (key === 'occasion' || (key === 'theme' && !url.searchParams.has(fields.occasion))) url.pathname = '/collections/' + resolve(url.searchParams, routes);
    url.searchParams.set('view', 'tgb-gift-finder');
    return url;
  }
  function eligible(products, params) {
    const min = cents(params.get(budgets[0])) ?? 0;
    const max = cents(params.get(budgets[1])) ?? Infinity;
    if (!Number.isFinite(min) || (max !== Infinity && !Number.isFinite(max)) || min < 0 || max < min) return [];
    const seen = new Set();
    return products.flatMap(product => {
      if (seen.has(product.id)) return [];
      seen.add(product.id);
      for (const [field, param] of Object.entries(fields)) {
        const requested = params.getAll(param).filter(Boolean);
        const values = Array.isArray(product[field]) ? product[field] : [product[field]];
        if (requested.length && !requested.some(value => values.includes(value))) return [];
      }
      const variants = (product.variants || []).filter(v => v.price >= min && v.price <= max);
      const available = variants.filter(v => v.available);
      const choice = (available.length ? available : variants).sort((a, b) => a.price - b.price)[0];
      return choice ? [{...product, choice}] : [];
    });
  }
  function cyoQuery(current) {
    const url = new URL(current);
    budgets.forEach(param => url.searchParams.delete(param));
    return url;
  }
  function submittedKind(explicitKind, currentKind, budget) {
    if (explicitKind === 'cyo') return 'cyo';
    return ['all', 'finished', 'cyo'].includes(currentKind) ? currentKind : budget ? 'finished' : 'all';
  }
  const allOccasionValues = "Appreciation|Birthday|Congratulations|Housewarming|Thinking of You|Welcome|Well Done".split('|');
  const isAllOccasion = product => Array.isArray(product.occasion) && allOccasionValues.every(value => product.occasion.includes(value));
  function prioritizeSpecific(matches, params) {
    if (!params.has(fields.occasion) && !params.has(fields.recipient)) return matches;
    return matches.sort((a,b) => Number(isAllOccasion(a)) - Number(isAllOccasion(b)));
  }
  const helpers = {fromChoices, relax, eligible, resolve, cents, cyoQuery, submittedKind, isAllOccasion, prioritizeSpecific};
  if (typeof module !== 'undefined' && module.exports) module.exports = helpers;
  if (typeof document === 'undefined') return;
  if (window.tgbFinderInitialized) return;
  window.tgbFinderInitialized = true;
  const cache = new Map();
  const money = amount => new Intl.NumberFormat('en-US', {style: 'currency', currency: 'USD'}).format(amount / 100);
  const el = (tag, className, text) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  };
  async function loadAll(current, kind = 'finished') {
    const url = kind === 'cyo' ? cyoQuery(current) : new URL(current);
    url.hash = '';
    ['page', 'tgb_page', 'tgb_cyo_page', 'gift_type', 'section_id'].forEach(key => url.searchParams.delete(key));
    url.searchParams.set('view', kind === 'cyo' ? 'tgb-finder-cyo-data' : 'tgb-finder-data');
    const previewRoot = document.querySelector('[data-tgb-finder]');
    if (previewRoot?.dataset.themeRole !== 'main') url.searchParams.set('preview_theme_id', window.Shopify?.theme?.id || '192146145594');
    const key = url.href;
    if (cache.has(key)) return cache.get(key);
    const promise = (async () => {
      let all = [];
      let pages = 1;
      for (let page = 1; page <= pages; page++) {
        url.searchParams.set('page', String(page));
        const response = await fetch(url.href, {credentials: 'same-origin', headers: {Accept: 'text/html'}});
        if (!response.ok) throw new Error('Gift results unavailable');
        const data = await response.json();
        if (!Array.isArray(data.products) || !Number.isInteger(data.pages) || data.pages > 10 || data.page !== page) throw new Error('Incomplete gift results');
        pages = data.pages;
        all.push(...data.products);
      }
      return all;
    })();
    cache.set(key, promise);
    try { return await promise; } catch (error) {cache.delete(key); throw error;}
  }
  function emitter(root) {
    const preview = root.dataset.themeRole !== 'main' || window.Shopify?.designMode || window.Shopify?.previewMode;
    if (!preview && !window.Shopify?.customerPrivacy && typeof window.Shopify?.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], () => {});
    }
    return (name, extras = {}) => {
      if (preview) return;
      const privacy = window.Shopify?.customerPrivacy;
      if (typeof privacy?.analyticsProcessingAllowed !== 'function' || !privacy.analyticsProcessingAllowed()) return;
      let journey;
      try {
        journey = sessionStorage.getItem('tgb_finder_journey');
        if (!journey) {journey = crypto.randomUUID(); sessionStorage.setItem('tgb_finder_journey', journey);}
      } catch (_) { return; }
      const selected = new URLSearchParams(location.search);
      const parameters = {finder_version: '2026-10-10', journey_id: journey, context_handle: root.dataset.collection || '', transport_type: 'beacon', send_to: 'G-SLBLC61301', ...extras};
      for (const [field, param] of Object.entries(fields)) {
        if (!(field in parameters)) parameters[field] = selected.getAll(param).join('|').slice(0, 100);
      }
      if (typeof window.gtag === 'function') window.gtag('event', name, parameters);
      else if (Array.isArray(window.dataLayer)) {
        (function () { window.dataLayer.push(arguments); })('event', name, parameters);
      }
    };
  }
  function initialize(scope = document) {
    scope.querySelectorAll('[data-tgb-finder]').forEach(root => {
      if (root.dataset.finderReady) return;
      root.dataset.finderReady = 'true';
      const routes = JSON.parse(root.querySelector('[data-finder-routes]').textContent);
      const emit = emitter(root);
      const form = root.querySelector('[data-finder-form]');
      form.querySelectorAll('[type=submit]').forEach(button => {button.disabled = false;});
      const results = root.hasAttribute('data-finder-results');
      const storageKey = 'tgb_finder_choices_v1';
      const current = new URL(location.href);
      let initial = {};
      if (!results) {try {initial = JSON.parse(sessionStorage.getItem(storageKey) || '{}');} catch (_) {}}
      for (const [field, param] of Object.entries(fields)) if (current.searchParams.has(param)) initial[field] = current.searchParams.get(param);
      const low = current.searchParams.get(budgets[0]); const high = current.searchParams.get(budgets[1]);
      if (low !== null || high !== null) initial.budget = (low || '0') + ':' + (high || '');
      for (const [key, value] of Object.entries(initial)) {
        const select = form.elements.namedItem(key);
        if (!select || !value) continue;
        if (![...select.options].some(option => option.value === value)) select.add(new Option(key === 'budget' ? 'Selected budget' : alias(value), value));
        select.value = value;
      }
      if (initial.theme) form.querySelector('.tgb-finder__more').open = true;
      const choices = () => Object.fromEntries(['occasion', 'budget', 'recipient', 'theme'].map(key => [key, form.elements.namedItem(key)?.value || '']));
      const reset = form.querySelector('[type=reset]');
      const persist = () => {const values = choices(); reset.hidden = !Object.values(values).some(Boolean); try {sessionStorage.setItem(storageKey, JSON.stringify(values));} catch (_) {} return values;};
      let started = false;
      const start = () => {if (!started) {started = true; emit('gift_finder_start', choices());}};
      form.addEventListener('change', event => {start(); const values = persist(); emit('gift_finder_select', {...values, selected_field: event.target.name});});
      form.addEventListener('submit', event => {
        event.preventDefault(); start(); const values = persist();
        const giftKind = submittedKind(event.submitter?.dataset.finderKind, results ? root.dataset.giftKind : null, values.budget);
        emit('gift_finder_submit', {...values, gift_type: giftKind, context_handle: resolve(fromChoices(values, routes, location.href).searchParams, routes)});
        const destination = fromChoices(values, routes, location.href);
        destination.searchParams.set('gift_type', giftKind);
        if (root.dataset.themeRole !== 'main') destination.searchParams.set('preview_theme_id', window.Shopify?.theme?.id || '192146145594');
        location.assign(destination.href);
      });
      form.addEventListener('reset', () => {
        queueMicrotask(() => {for (const key of ['occasion','budget','recipient','theme']) form.elements.namedItem(key).value = ''; form.querySelector('.tgb-finder__more').open = false;persist(); emit('gift_finder_clear');});
      });
      persist();
      root.querySelectorAll('[data-finder-budget-shortcut]').forEach(link => {
        if (root.dataset.themeRole !== 'main') {const url = new URL(link.href);url.searchParams.set('preview_theme_id', window.Shopify?.theme?.id || '192146145594');link.href = url.href;}
      });
      if (!results) {
        const observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) {emit('gift_finder_view'); observer.disconnect();}
        }, {threshold: 0.25});
        observer.observe(root);
        return;
      }
      const chips = root.querySelector('[data-finder-chips]');
      const additionalChips = [...chips.querySelectorAll('[data-native-filter-param]')].filter(link => !Object.values(fields).includes(link.dataset.nativeFilterParam));
      chips.replaceChildren(...additionalChips);
      const chip = (key, text) => {
        const url = relax(location.href, key, routes);const link = el('a', '', text + ' ×');link.href = url.href;
        link.addEventListener('click', () => emit('gift_finder_relax', {relaxation_type: key}));chips.append(link);
      };
      for (const [field, param] of Object.entries(fields)) {
        const selected = current.searchParams.getAll(param).filter(Boolean);
        if (selected.length) chip(field, ({occasion:'Occasion',recipient:'Recipient',theme:'Gift style'}[field]) + ': ' + selected.map(alias).join(', '));
      }
      if (low !== null || high !== null) chip('budget', 'Budget: ' + (low === '0' && high === '74.99' ? 'Under $75' : high ? money(cents(low || '0')) + '–' + money(cents(high)) : money(cents(low)) + '+'));
      if (chips.childElementCount) {
        const clear = fromChoices({}, routes, location.href);const link = el('a', '', 'Clear all');link.href = clear.href;link.addEventListener('click', () => emit('gift_finder_clear'));chips.append(link);
      }
      const sort = root.querySelector('[data-finder-sort]');
      const selectedSort = current.searchParams.get('sort_by') || 'best-selling';
      if (![...sort.options].some(option => option.value === selectedSort)) sort.add(new Option(selectedSort, selectedSort));
      sort.value = selectedSort;
      sort.addEventListener('change', () => {const url = new URL(location.href);url.searchParams.set('sort_by', sort.value);['page','tgb_page','tgb_cyo_page'].forEach(key => url.searchParams.delete(key));location.assign(url.href);});
      const finishedGroup = root.querySelector('[data-finder-finished]');
      const cyoGroup = root.querySelector('[data-finder-cyo]');
      const kindButtons = [...root.querySelectorAll('[data-finder-kind-picker] [data-finder-kind]')];
      function selectKind(kind, updateUrl = false) {
        if (!['all','finished','cyo'].includes(kind)) kind = (low || high) ? 'finished' : 'all';
        finishedGroup.hidden = kind === 'cyo'; cyoGroup.hidden = kind === 'finished';
        kindButtons.forEach(button => {button.disabled = false;button.setAttribute('aria-pressed',String(button.dataset.finderKind === kind));});
        root.dataset.giftKind = kind;
        if (updateUrl) {
          const url = new URL(location.href);url.searchParams.set('gift_type',kind);history.replaceState(null,'',url.href);
          root.querySelectorAll('[data-finder-chips] a,[data-finder-pagination] a,[data-finder-cyo-pagination] a,[data-finder-recovery] a,[data-finder-cyo-recovery] a').forEach(link => {
            const target = new URL(link.href);if (target.searchParams.get('view') !== 'tgb-gift-finder') return;
            target.searchParams.set('gift_type',kind);link.href = target.href;
          });
        }
      }
      kindButtons.forEach(button => button.addEventListener('click', () => {selectKind(button.dataset.finderKind,true);emit('gift_finder_select',{selected_field:'gift_type',gift_type:button.dataset.finderKind});}));
      selectKind(current.searchParams.get('gift_type'));
      const count = root.querySelector('[data-finder-count]');const grid = root.querySelector('[data-finder-grid]');const pagination = root.querySelector('[data-finder-pagination]');
      function card(product, kind = 'finished') {
        const li = el('li', 'tgb-finder-card');const link = el('a','tgb-finder-card__link');
        const destination = new URL(product.url, location.origin); destination.searchParams.set('variant', product.choice.id);
        if (root.dataset.themeRole !== 'main') destination.searchParams.set('preview_theme_id', window.Shopify?.theme?.id || '192146145594');
        link.href = destination.href;link.dataset.giftId = product.id;link.dataset.priceCents = product.choice.price;link.dataset.giftKind = kind;
        link.addEventListener('click', () => emit('gift_finder_product_click', {product_id: String(product.id), price: product.choice.price / 100,gift_type:kind,price_basis:kind === 'cyo' ? 'starting_container' : 'complete_gift'}));
        if (product.image) {const image = el('img','tgb-finder-card__image');image.src = product.image;image.alt = product.alt || product.title;image.loading = 'lazy';image.width = 600;image.height = 600;link.append(image);}
        const body = el('div', 'tgb-finder-card__body');body.append(el('h3','',product.title));
        const price = el('p','tgb-finder-card__price',(kind === 'cyo' ? 'Starting at ' : '') + money(product.choice.price));price.append(el('span','',kind === 'cyo' ? 'container · contents extra' : 'complete gift'));body.append(price);
        if (kind === 'cyo') body.append(el('p','tgb-finder-card__cue',(isAllOccasion(product) ? 'A versatile choice for general occasions. ' : '') + 'Choose the contents on the gift page.'));
        else if (product.cue) body.append(el('p','tgb-finder-card__cue',product.cue));
        if (Number(product.ratingCount) > 0 && Number(product.rating) > 0) body.append(el('p','tgb-finder-card__reviews','★ ' + Number(product.rating).toFixed(1) + ' · ' + product.ratingCount + ' reviews'));
        body.append(el('p','tgb-finder-card__availability',product.choice.available ? 'Available to order' : 'Sold out'),el('span','tgb-finder-card__action',kind === 'cyo' ? 'Create this gift →' : 'View gift →'));link.append(body);
        const delivery = el('a','tgb-finder-card__delivery','Delivery details');delivery.href = '/pages/delivery-information';li.append(link, delivery);return li;
      }
      async function recover(matches, kind = 'finished') {
        const isCyo = kind === 'cyo';
        const container = root.querySelector(isCyo ? '[data-finder-cyo-recovery]' : '[data-finder-recovery]');container.hidden = false;container.replaceChildren();
        container.append(el('h2','',matches.length === 0 ? (isCyo ? 'No Create Your Own options match all these choices.' : 'No complete gifts match all these choices.') : (isCyo ? 'A few Create Your Own options match your choices.' : 'A few gifts match your choices.')));
        container.append(el('p','',matches.length === 0 ? (isCyo ? 'Your choices are still selected. Try changing one preference below.' : 'Your choices are still selected. Try changing one preference or adjusting the budget.') : 'Keep these matches, or broaden one preference to see more options.'));
        const alternatives = el('div','tgb-finder__alternatives');container.append(alternatives);
        const keys = ['recipient', 'theme', 'occasion', 'budget'].filter(key => key === 'budget' ? !isCyo && (low !== null || high !== null) : current.searchParams.has(fields[key]));
        await Promise.all(keys.map(async key => {
          const url = relax(location.href, key, routes);
          try {
            const params = isCyo ? cyoQuery(url.href).searchParams : url.searchParams;
            const total = eligible(await loadAll(url.href, kind), params).length;
            if (total <= matches.length) return;
            const label = {recipient:'Any recipient', theme:'Any gift style', occasion:'Any occasion', budget:'Any budget'}[key];
            const link = el('a','',label + ' — ' + total + (isCyo ? (total === 1 ? ' Create Your Own option' : ' Create Your Own options') : (total === 1 ? ' complete gift' : ' complete gifts')));url.searchParams.set('gift_type',isCyo ? 'cyo' : root.dataset.giftKind);link.href = url.href;
            link.addEventListener('click', () => emit('gift_finder_relax', {relaxation_type: key, alternative_count: total,gift_type:kind}));alternatives.append(link);
          } catch (_) { /* Never display an unverified alternative count. */ }
        }));
        const help = el('a','','Get help from our Texas team');help.href = '/pages/contact';alternatives.append(help);
      }
      async function show() {
        count.textContent = 'Finding all complete gift matches…';
        try {
          const products = await loadAll(location.href);const matches = eligible(products, current.searchParams);
          if (selectedSort === 'price-ascending') matches.sort((a,b) => a.choice.price - b.choice.price);
          if (selectedSort === 'price-descending') matches.sort((a,b) => b.choice.price - a.choice.price);
          root.dataset.completeGiftCount = String(matches.length);
          const pageSize = 24;const pages = Math.ceil(matches.length / pageSize);
          const page = Math.min(Math.max(1, parseInt(current.searchParams.get('tgb_page') || '1',10) || 1), Math.max(1,pages));
          count.textContent = matches.length + (matches.length === 1 ? ' complete gift matches' : ' complete gifts match') + ' your choices.';
          kindButtons.find(button => button.dataset.finderKind === 'finished').textContent = 'Ready to Give (' + matches.length + ')';
          grid.replaceChildren(...matches.slice((page-1)*pageSize,page*pageSize).map(product => card(product)));pagination.replaceChildren();
          for (let number=1;number<=pages;number++) {
            const url=new URL(location.href);url.searchParams.delete('page');url.searchParams.set('tgb_page',String(number));url.searchParams.set('gift_type',root.dataset.giftKind);
            const link=el('a','',String(number));link.href=url.href;link.setAttribute('aria-label','Results page '+number);
            if(number===page)link.setAttribute('aria-current','page');pagination.append(link);
          }
          emit('gift_finder_results',{complete_gift_count:matches.length,result_class:matches.length===0?'zero':matches.length<=3?'thin':'normal'});
          if(matches.length<=3)await recover(matches);
        } catch (error) {
          console.warn('TGB gift finder: complete results unavailable', error.message);
          count.textContent='We couldn’t load the full list. The complete gifts shown are from this page.';
          const retry=el('button','tgb-finder__reset','Try again');retry.type='button';retry.addEventListener('click',()=>{retry.remove();show();});count.append(' ',retry);
        }
      }
      async function showCyo() {
        const cyoCount = root.querySelector('[data-finder-cyo-count]');
        const cyoGrid = root.querySelector('[data-finder-cyo-grid]');
        const cyoPagination = root.querySelector('[data-finder-cyo-pagination]');
        const hasBudget = low !== null || high !== null;
        root.querySelector('[data-finder-cyo-note]').textContent = hasBudget
          ? 'Your budget filters complete gifts only. These are starting container prices; contents cost extra. Check the final total as you build.'
          : 'Start with a keepsake container and choose the contents. Prices below are for the container; contents cost extra.';
        const occasion = current.searchParams.get(fields.occasion);
        root.querySelector('[data-finder-cyo-title]').textContent = occasion ? 'Create Your Own ' + alias(occasion) + ' gifts' : 'Create Your Own gifts';
        cyoCount.textContent = 'Finding Create Your Own options…';
        try {
          const params = cyoQuery(location.href).searchParams;
          const matches = eligible(await loadAll(location.href,'cyo'),params);
          if (['best-selling','manual'].includes(selectedSort)) prioritizeSpecific(matches, params);
          if (selectedSort === 'price-ascending') matches.sort((a,b) => a.choice.price - b.choice.price);
          if (selectedSort === 'price-descending') matches.sort((a,b) => b.choice.price - a.choice.price);
          root.dataset.cyoGiftCount = String(matches.length);
          kindButtons.find(button => button.dataset.finderKind === 'cyo').textContent = 'Create Your Own (' + matches.length + ')';
          cyoCount.textContent = matches.length ? matches.length + ' Create Your Own ' + (matches.length === 1 ? 'option matches' : 'options match') + (hasBudget ? ' your other choices.' : ' your choices.') : 'No Create Your Own options match ' + (hasBudget ? 'your other choices.' : 'these choices.');
          const pageSize = 12;const pages = Math.ceil(matches.length / pageSize);
          const page = Math.min(Math.max(1,parseInt(current.searchParams.get('tgb_cyo_page') || '1',10) || 1),Math.max(1,pages));
          cyoGrid.replaceChildren(...matches.slice((page-1)*pageSize,page*pageSize).map(product => card(product,'cyo')));cyoPagination.replaceChildren();
          for (let number = 1;number <= pages;number++) {
            const url = new URL(location.href);url.searchParams.delete('page');url.searchParams.set('tgb_cyo_page',String(number));url.searchParams.set('gift_type',root.dataset.giftKind);url.hash = 'CreateYourOwnMatches';
            const link = el('a','',String(number));link.href = url.href;link.setAttribute('aria-label','Create Your Own results page ' + number);
            if (number === page) link.setAttribute('aria-current','page');cyoPagination.append(link);
          }
          emit('gift_finder_cyo_results',{cyo_gift_count:matches.length,price_basis:'starting_container',complete_budget_applied:false});
          if (matches.length <= 3) await recover(matches, 'cyo');
        } catch (error) {
          console.warn('TGB gift finder: Create Your Own results unavailable',error.message);
          cyoCount.textContent = 'We couldn’t load Create Your Own options. You can try again or browse all containers below.';
          const retry = el('button','tgb-finder__reset','Try again');retry.type = 'button';retry.addEventListener('click',() => {retry.remove();showCyo();});cyoCount.append(' ',retry);
        }
      }
      show();
      showCyo();
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
